import Phaser from 'phaser'

export default class DoubleClickableImage extends Phaser.GameObjects.Image
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(scene, x, y, key)
    {
        super(scene, x, y, key);

        this.totalClicks = 0;

        this.setInteractive({pixelPerfect:true});

        this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.countClicks, this);
    }

    countClicks()
    {
        this.totalClicks++;

        if (this.totalClicks == 1)
        {
            this.startTime = this.scene.time.now;

        } 
        else if (this.totalClicks == 2)
        {
            let endTime = this.scene.time.now;
            let diff = endTime - this.startTime;

            if (diff < 300)
            {
                if (this.doubleClickAction)
                {
                    this.doubleClickAction(this);
                }
            } 
            else
            {
                this.startTime = this.scene.time.now;
                this.totalClicks = 1;
            }
        }
    }
}